export const convertLinksToTags = (text: string) => {
  const regex =
    /(?:https?:\/\/)?(?:www\.)?(?:[\da-z\.-]+)\.(?:[a-z\.]{2,6})(?:\/[^\s]*)?/g;
  const matches = text.match(regex);

  if (matches) {
    matches.forEach(match => {
      text = text.replace(
        match,
        `<a href="${match}" target="_blank">${match}</a>`,
      );
    });
  }
  return text;
};
